import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { processSteps } from '../mock';

export const Process = () => {
  return (
    <section id="process" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-yellow-500 font-semibold text-sm uppercase tracking-wider mb-3">
            Auftrag-Ablauf
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Wie läuft ein Auftrag mit uns?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Transparenz von Anfang an – so arbeiten wir Schritt für Schritt mit Ihnen zusammen.
          </p>
        </div>

        {/* Process Timeline */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Desktop: Vertical Line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-yellow-500 via-yellow-600 to-red-600"></div>

            {/* Steps */}
            <div className="space-y-12 md:space-y-12">
              {processSteps.map((step, index) => (
                <div key={step.step} className="relative">
                  {/* Desktop Layout */}
                  <div
                    className={`hidden md:flex items-center gap-8 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    {/* Content Card */}
                    <div className="w-full md:w-5/12">
                      <div className="bg-gray-800 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-yellow-500/20 hover:border-yellow-500/50">
                        <div className="flex items-center space-x-4 mb-4">
                          <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                            {step.step}
                          </div>
                          <h3 className="text-2xl font-bold text-white">{step.title}</h3>
                        </div>
                        <p className="text-gray-300 leading-relaxed">{step.description}</p>
                      </div>
                    </div>

                    {/* Center Circle */}
                    <div className="w-2/12 flex justify-center">
                      <div className="w-6 h-6 bg-gray-900 border-4 border-yellow-500 rounded-full z-10 shadow-lg"></div>
                    </div>

                    {/* Spacer */}
                    <div className="w-5/12"></div>
                  </div>

                  {/* Mobile Layout with Arrow */}
                  <div className="md:hidden">
                    <div className="bg-gray-800 p-6 rounded-2xl shadow-lg border border-yellow-500/20">
                      <div className="flex items-center space-x-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg flex-shrink-0">
                          {step.step}
                        </div>
                        <h3 className="text-xl font-bold text-white">{step.title}</h3>
                      </div>
                      <p className="text-gray-300 leading-relaxed">{step.description}</p>
                    </div>
                    
                    {/* Arrow pointing to next step - Mobile only */}
                    {index < processSteps.length - 1 && (
                      <div className="flex justify-center my-6">
                        <svg className="w-8 h-12 text-yellow-500 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 bg-green-500/20 border border-green-500/50 px-6 py-3 rounded-full mb-6">
            <CheckCircle2 className="w-5 h-5 text-green-400" />
            <span className="text-green-300 font-semibold">Kostenlose Erstberatung</span>
          </div>
          <h3 className="text-3xl font-bold text-white mb-4">Bereit für Ihr Projekt?</h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Kontaktieren Sie uns noch heute für eine kostenlose Erstberatung und ein unverbindliches Angebot.
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:scale-105 shadow-xl"
          >
            Jetzt kostenlos beraten lassen
          </button>
        </div>
      </div>
    </section>
  );
};